import * as React from "react";
const SvgSelfUpholdingGridStructure20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M-.367 19.774 10 11.292l10.367 8.482 1.266-1.548L11.58 10l10.054-8.226L20.367.226 10 8.708-.367.226l-1.266 1.548L8.42 10l-10.054 8.226 1.266 1.548ZM10 6.124l-1-.818V1h2v4.306l-1 .818Zm-9 7.363 2-1.636V8.149L1 6.513v6.974Zm9 .39-1 .817V19h2v-4.305l-1-.819Zm9-7.365v6.976l-2-1.637V8.15l2-1.637Z",
      clipRule: "evenodd"
    })
  );
export default SvgSelfUpholdingGridStructure20Px;
